const RuleOperators = [
  { id: 1, code: 'equal', name: '=' },
  { id: 2, code: 'notEqual', name: '!' },
  { id: 3, code: 'greaterThan', name: '>' },
  { id: 5, code: 'lessThan', name: '<' },
  { id: 4, code: 'greaterThanInclusive', name: '>=' },
  { id: 6, code: 'lessThanInclusive', name: '<=' }
]

const RuleColors = {
  any: {
    background: '#D1A208',
    border: '#fcdd80'
  },
  all: {
    background: '#1F618D',
    border: '#85C1E9'
  }
}

const getColorFromResult = (defaultColor, result) => {
  if (result === true) {
    return 'green'
  }
  if (result === false) {
    return 'red'
  }
  return defaultColor
}

export { RuleOperators, RuleColors, getColorFromResult }
